/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkFaxToReferralRequest
 */
export interface LinkFaxToReferralRequest {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    include_in_ai_analysis: boolean;
}

/**
 * Check if a given object implements the LinkFaxToReferralRequest interface.
 */
export function instanceOfLinkFaxToReferralRequest(value: object): value is LinkFaxToReferralRequest {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('include_in_ai_analysis' in value) || value['include_in_ai_analysis'] === undefined) return false;
    return true;
}

export function LinkFaxToReferralRequestFromJSON(json: any): LinkFaxToReferralRequest {
    return LinkFaxToReferralRequestFromJSONTyped(json, false);
}

export function LinkFaxToReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkFaxToReferralRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'include_in_ai_analysis': json['include_in_ai_analysis'],
    };
}

export function LinkFaxToReferralRequestToJSON(json: any): LinkFaxToReferralRequest {
    return LinkFaxToReferralRequestToJSONTyped(json, false);
}

export function LinkFaxToReferralRequestToJSONTyped(value?: LinkFaxToReferralRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'include_in_ai_analysis': value['include_in_ai_analysis'],
    };
}

